module.exports = __webpack_public_path__ + "static/cv-6ad5d85a4235352eebd1a910b64e83ef.pdf";